var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleWave1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1784.014,
    height: 195.107,
    viewBox: "0 0 1784.014 195.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2768",
    "data-name": "Path 2768",
    d: "M1424.409,483.62c-81.88-18.755-403.077-82.683-455.513,55.07-60.187,158.121-220.963-56.726-322.452-30.958-63.938,16.233-79.135,32.207-67.9,45.792,7.075,8.566,23.072,16.064,43.836,22.509,16.951,5.261,24.6,11.7,20.849,17.7-9.619,15.494-81.413,30.734-245.3,32.158-234.807,2.042-251.051-61.222-343.608-68.2-18.512-1.4-144.094,53.7-162.137,53.025-72.965-2.74-139.353-.313-167.764,3.078-33.073,3.95-77.878,6.149-84.021,6.419v27.307l1784.014-.191Z",
    transform: "translate(359.604 -452.418)",
    fill: "#8784d8",
    opacity: 0.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleWave1);
export default __webpack_public_path__ + "static/media/purpleWave1.61e343dc1a49d18a6bf6657d1f21db25.svg";
export { ForwardRef as ReactComponent };